<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-stock-body">
            <div class="dw-stock-center">
                <span class="dw-stock-big-num">{{ totalItems }}</span>
                <span class="dw-stock-big-lbl">Toplam Ürün</span>
            </div>
            <div class="dw-metrics">
                <div class="dw-metric">
                    <i class="bi bi-cash-stack" style="color: var(--bs-success)"></i>
                    <div class="dw-metric-text">
                        <span class="dw-metric-val">{{ totalValueFormatted }}</span>
                        <span class="dw-metric-lbl">Stok Değeri</span>
                    </div>
                </div>
                <div class="dw-metric-sep"></div>
                <div class="dw-metric">
                    <i class="bi bi-exclamation-triangle" style="color: var(--bs-danger)"></i>
                    <div class="dw-metric-text">
                        <span class="dw-metric-val" style="color: var(--bs-danger)">{{ lowStockCount }}</span>
                        <span class="dw-metric-lbl">Düşük Stok</span>
                    </div>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'stock',
    titleKey: 'common.dashboard.widgetTitles.stock',
    icon: 'bi-box-seam',
    accent: 'var(--bs-info)',
    accentBg: 'rgba(var(--bs-info-rgb, 114, 57, 234), 0.12)',
    glassRgb: '114, 57, 234',
    defaultCol: 1,
    defaultRow: 1,
    source: { type: 'statistics', key: 'stock' },
};

export default {
    name: 'StockWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        totalItems() {
            return (this.apiData?.total_items ?? 0).toLocaleString('tr-TR');
        },
        totalValueFormatted() {
            const n = parseFloat(this.apiData?.total_value) || 0;
            return n.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 });
        },
        lowStockCount() {
            return this.apiData?.low_stock_count ?? 0;
        },
    },
};
</script>
